import { Checkbox, Stack } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { ItemProps } from "react-virtuoso";
import { VirtuosoItem } from "../GroupedVirtualized/Item";
import { useGroupedVirtualizedSelectContext } from "./context";

export const VirtuosoSelectItem = forwardRef(function VirtuosoSelectItem<D>(
  { item, style, children, ...props }: ItemProps<D>,
  ref?: Ref<HTMLDivElement>
) {
  const { hideCheckboxes, slotProps, isSelected, addItem, deleteItem } = useGroupedVirtualizedSelectContext();

  return (
    <Stack
      {...props}
      direction="row"
      {...slotProps?.selectItem}
      style={style}
      ref={ref}
      sx={{
        alignItems: "center",
      }}
    >
      <Checkbox
        {...slotProps?.selectItemCheckbox}
        sx={{ ...(hideCheckboxes && { display: "none" }), ...slotProps?.selectItemCheckbox?.sx }}
        checked={isSelected(item)}
        onChange={(evt) => (evt.target.checked ? addItem(item) : deleteItem(item))}
      />
      <VirtuosoItem {...props} item={item}>
        {children}
      </VirtuosoItem>
    </Stack>
  );
});
